import {isEmpty} from 'lodash';

const formatViewershipStats = (broadcasters, overviewMetrics, overviewComparisonMetrics) => {
  return !isEmpty(overviewMetrics)
    ? [
        {
          key: 'total-vm',
          label: 'Total Viewable Minutes',
          value: overviewMetrics.twitch_viewable_minutes + overviewMetrics.youtube_viewable_minutes,
          oldValue:
            overviewComparisonMetrics.twitch_viewable_minutes +
            overviewComparisonMetrics.youtube_viewable_minutes -
            (overviewMetrics.twitch_viewable_minutes + overviewMetrics.youtube_viewable_minutes),
          firstThreshold: 0.01,
          secondThreshold: 0.2,
        },
        {
          key: 'campaign-participants',
          label: 'Campaign Participants',
          value: broadcasters?.length,
        },
        {
          key: 'twitch-total-vm',
          label: 'Twitch Total Viewable Minutes',
          value: overviewMetrics.twitch_viewable_minutes,
        },
        {
          key: 'twitch-peak-viewers',
          label: 'Twitch Peak Concurrent Viewers',
          value: overviewMetrics.twitch_peak_viewers,
        },
        {
          key: 'avg-viewers',
          label: 'Twitch Avg Concurrent Viewers',
          value: overviewMetrics.twitch_average_viewers,
        },
        {
          key: 'youtube-total-vm',
          label: 'Youtube Total Viewable Minutes',
          value: overviewMetrics.youtube_viewable_minutes,
        },
        {
          key: 'youtube-peak-viewers',
          label: 'Youtube Peak Concurrent Viewers',
          value: overviewMetrics.youtube_peak_viewers,
        },
        {
          key: 'avg-viewers',
          label: 'Youtube Avg Concurrent Viewers',
          value: overviewMetrics.youtube_average_viewers,
        },
      ]
    : [];
};

export default formatViewershipStats;
